import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const appl4ValidationSchema = () => {
  const { t } = useTranslation();
  const minDate = new Date("1900-01-01");
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    boardDate: yup
      .date()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(minDate, t("Η ημερομηνία πρέπει να είναι μετά την 01/01/1900"))
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
    fudocIsologismos: yup
      .string()
      .nullable()
      .when(["internationalAccounting", "singleFile", "category"], {
        is: (
          internationalAccounting: string,
          singleFile: string,
          category: string,
        ) => {
          return !!category && !internationalAccounting && !singleFile;
        },
        then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        otherwise: (schema) => schema,
      }),
    fudocProsartima: yup
      .string()
      .nullable()
      .when(
        ["internationalAccounting", "singleFile"],
        ([internationalAccounting, singleFile], schema) => {
          if (!!internationalAccounting || !!singleFile) {
            return schema.notRequired();
          } else {
            return schema.required(t("Το πεδίο είναι υποχρεωτικό"));
          }
        },
      ),
    fudocEkthesiDS: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    usageFromDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .test(
        "is-before",
        t(
          "Η ημερομηνία 'Ισολογισμού Χρήσης Από' πρέπει να είναι πριν από την ημερομηνία 'Ισολογισμού Χρήσης Έως'.",
        ),
        function (value) {
          const { usageToDate } = this.parent;
          if (value && usageToDate && new Date(value) > new Date(usageToDate)) {
            return false;
          }
          return true;
        },
      ),
    usageToDate: yup
      .date()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
  });
};
